import React from 'react';
import PropTypes from 'prop-types';

import { UserContainer, UserName }  from '../ChatUserRowOption/components';
import {ReactComponent as DeleteIcon} from "../../../../img/icon-delete.svg";
import {ReactComponent as CircleIcon} from "../../../../img/icon-circle.svg";
import Icon from "../../Common/Icon";
import ConfigService from "../../../Services/api/Config";

const ChatUserDeleteOption = ({ user, onClick }) => {
  return (
    <UserContainer backgroundColor={ ConfigService.getColor('tertiaryColor')}>
      <Icon
        width='10'
        height='10'
        color={ user.online ? 'successColor' : 'errorColor' }
      >
        <CircleIcon alt='icon-circle'/>
      </Icon>
      <UserName>
        {user.name}
      </UserName>
      <Icon
        width='16'
        height='16'
        color='primaryColor'
        position='Right'
        onClick={() => onClick(user)}
      >
        <DeleteIcon alt='icon-delete'/>
      </Icon>
    </UserContainer>
  )
};

ChatUserDeleteOption.propTypes = {
  user: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default React.memo(ChatUserDeleteOption);